function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 0C24.8362 0 32 7.16384 32 16C32 24.8362 24.8358 32 16 32C7.16416 32 0 24.8381 0 16C0 7.16192 7.16288 0 16 0Z",
  fill: "#53AE94"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9747 13.8681V11.4879H23.4176V7.86133H8.59643V11.4879H14.04V13.8662C9.61595 14.0694 6.28955 14.9455 6.28955 15.9951C6.28955 17.0447 9.61755 17.9209 14.04 18.1254V25.7494H17.976V18.1247C22.392 17.9209 25.7116 17.0454 25.7116 15.9967C25.7116 14.9481 22.392 14.0726 17.976 13.8687L17.9747 13.8681ZM17.976 17.479V17.4771C17.8649 17.4841 17.2944 17.5183 16.024 17.5183C15.0083 17.5183 14.2937 17.4895 14.0419 17.4764V17.4796C10.1334 17.3065 7.21595 16.6258 7.21595 15.8114C7.21595 14.997 10.1337 14.3174 14.0419 14.1439V16.8015C14.2979 16.8191 15.03 16.8623 16.0406 16.8623C17.2544 16.8623 17.8646 16.8118 17.9766 16.8015V14.1439C21.8774 14.3177 24.7881 14.999 24.7881 15.8105C24.7881 16.622 21.8761 17.3036 17.9766 17.4774",
  fill: "white"
});
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.82e99c7994bb5638cca91c4186fb4380.svg";
export { ForwardRef as ReactComponent };